"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpeechSynthesisVoice = exports.SpeechSynthesisUtterance = exports.SpeechSynthesisEvent = exports.speechSynthesis = void 0;

var _es = _interopRequireWildcard(require("event-target-shim/es5"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var SpeechSynthesisEvent = /*#__PURE__*/function (_Event) {
  _inherits(SpeechSynthesisEvent, _Event);

  var _super = _createSuper(SpeechSynthesisEvent);

  function SpeechSynthesisEvent(type, utterance) {
    var _this;

    _classCallCheck(this, SpeechSynthesisEvent);

    _this = _super.call(this, type);
    _this._utterance = utterance;
    return _this;
  }

  _createClass(SpeechSynthesisEvent, [{
    key: "charIndex",
    get: function get() {
      return 0;
    }
  }, {
    key: "elapsedTime",
    get: function get() {
      return 0;
    }
  }, {
    key: "name",
    get: function get() {}
  }, {
    key: "utterance",
    get: function get() {
      return this._utterance;
    }
  }]);

  return SpeechSynthesisEvent;
}(_es.Event);

exports.SpeechSynthesisEvent = SpeechSynthesisEvent;

var SpeechSynthesisUtterance = /*#__PURE__*/function (_EventTarget) {
  _inherits(SpeechSynthesisUtterance, _EventTarget);

  var _super2 = _createSuper(SpeechSynthesisUtterance);

  function SpeechSynthesisUtterance(text) {
    var _this2;

    _classCallCheck(this, SpeechSynthesisUtterance);

    _this2 = _super2.call(this);
    _this2._lang = 'en-US';
    _this2._pitch = 1;
    _this2._rate = 1;
    _this2._text = text;
    _this2._voice = null;
    _this2._volume = 1;
    return _this2;
  }

  _createClass(SpeechSynthesisUtterance, [{
    key: "lang",
    get: function get() {
      return this._lang;
    },
    set: function set(value) {
      this._lang = value;
    }
  }, {
    key: "pitch",
    get: function get() {
      return this._pitch;
    },
    set: function set(value) {
      this._pitch = value;
    }
  }, {
    key: "rate",
    get: function get() {
      return this._rate;
    },
    set: function set(value) {
      this._rate = value;
    }
  }, {
    key: "text",
    get: function get() {
      return this._text;
    },
    set: function set(value) {
      this._text = value;
    }
  }, {
    key: "voice",
    get: function get() {
      return this._voice;
    },
    set: function set(value) {
      this._voice = value;
    }
  }, {
    key: "volume",
    get: function get() {
      return this._volume;
    },
    set: function set(value) {
      this._volume = value;
    }
  }, {
    key: "onboundary",
    get: function get() {
      return (0, _es.getEventAttributeValue)(this, 'boundary');
    },
    set: function set(value) {
      (0, _es.setEventAttributeValue)(this, 'boundary', value);
    }
  }, {
    key: "onend",
    get: function get() {
      return (0, _es.getEventAttributeValue)(this, 'end');
    },
    set: function set(value) {
      (0, _es.setEventAttributeValue)(this, 'end', value);
    }
  }, {
    key: "onerror",
    get: function get() {
      return (0, _es.getEventAttributeValue)(this, 'error');
    },
    set: function set(value) {
      (0, _es.setEventAttributeValue)(this, 'error', value);
    }
  }, {
    key: "onmark",
    get: function get() {
      return (0, _es.getEventAttributeValue)(this, 'mark');
    },
    set: function set(value) {
      (0, _es.setEventAttributeValue)(this, 'mark', value);
    }
  }, {
    key: "onpause",
    get: function get() {
      return (0, _es.getEventAttributeValue)(this, 'pause');
    },
    set: function set(value) {
      (0, _es.setEventAttributeValue)(this, 'pause', value);
    }
  }, {
    key: "onresume",
    get: function get() {
      return (0, _es.getEventAttributeValue)(this, 'resume');
    },
    set: function set(value) {
      (0, _es.setEventAttributeValue)(this, 'resume', value);
    }
  }, {
    key: "onstart",
    get: function get() {
      return (0, _es.getEventAttributeValue)(this, 'start');
    },
    set: function set(value) {
      (0, _es.setEventAttributeValue)(this, 'start', value);
    }
  }]);

  return SpeechSynthesisUtterance;
}(_es.default);

exports.SpeechSynthesisUtterance = SpeechSynthesisUtterance;

var SpeechSynthesisVoice = /*#__PURE__*/function () {
  function SpeechSynthesisVoice() {
    _classCallCheck(this, SpeechSynthesisVoice);
  }

  _createClass(SpeechSynthesisVoice, [{
    key: "default",
    get: function get() {
      return true;
    }
  }, {
    key: "lang",
    get: function get() {
      return 'en-US';
    }
  }, {
    key: "localService",
    get: function get() {
      return true;
    }
  }, {
    key: "name",
    get: function get() {
      return 'English (US)';
    }
  }, {
    key: "voiceURI",
    get: function get() {
      return 'English (US)';
    }
  }]);

  return SpeechSynthesisVoice;
}();

exports.SpeechSynthesisVoice = SpeechSynthesisVoice;

var SpeechSynthesis = /*#__PURE__*/function (_EventTarget2) {
  _inherits(SpeechSynthesis, _EventTarget2);

  var _super3 = _createSuper(SpeechSynthesis);

  function SpeechSynthesis() {
    _classCallCheck(this, SpeechSynthesis);

    return _super3.apply(this, arguments);
  }

  _createClass(SpeechSynthesis, [{
    key: "paused",
    get: function get() {
      return false;
    }
  }, {
    key: "pending",
    get: function get() {
      return false;
    }
  }, {
    key: "speaking",
    get: function get() {
      return false;
    }
  }, {
    key: "cancel",
    value: function cancel() {}
  }, {
    key: "getVoices",
    value: function getVoices() {
      return [new SpeechSynthesisVoice()];
    }
  }, {
    key: "pause",
    value: function pause() {
      throw new Error('pause is not implemented.');
    }
  }, {
    key: "resume",
    value: function resume() {
      throw new Error('resume is not implemented.');
    }
  }, {
    key: "speak",
    value: function speak(utterance) {
      utterance.dispatchEvent(new SpeechSynthesisEvent('start', utterance));
      utterance.dispatchEvent(new SpeechSynthesisEvent('end', utterance));
    }
  }, {
    key: "onvoiceschanged",
    get: function get() {
      return (0, _es.getEventAttributeValue)(this, 'voiceschanged');
    },
    set: function set(value) {
      (0, _es.setEventAttributeValue)(this, 'voiceschanged', value);
    }
  }]);

  return SpeechSynthesis;
}(_es.default);

var speechSynthesis = new SpeechSynthesis();
exports.speechSynthesis = speechSynthesis;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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